import { MODULE_CODES } from "@medicorepay/shared";
import { Navigate, Route } from "react-router-dom";
import { ModuleProtectedRoute } from "../../components/auth/ModuleProtectedRoute";
import { PermissionProtectedRoute } from "../../components/auth/PermissionProtectedRoute";
import { BillingSessionsPage } from "../../pages/billing-sessions/BillingSessionsPage";
import { CloseBillingSessionPage } from "../../pages/billing-sessions/CloseBillingSessionPage";
import { OpenBillingSessionPage } from "../../pages/billing-sessions/OpenBillingSessionPage";
import { ViewBillingSessionPage } from "../../pages/billing-sessions/ViewBillingSessionPage";
import CreateDiscountSchemePage from "../../pages/discount-schemes/CreateDiscountSchemePage";
import DiscountSchemesPage from "../../pages/discount-schemes/DiscountSchemesPage";
import EditDiscountSchemePage from "../../pages/discount-schemes/EditDiscountSchemePage";
import { CreateDoctorPage } from "../../pages/doctors/CreateDoctorPage";
import { DoctorsPage } from "../../pages/doctors/DoctorsPage";
import { EditDoctorPage } from "../../pages/doctors/EditDoctorPage";
import { ViewDoctorPage } from "../../pages/doctors/ViewDoctorPage";
import CreateDrugGenericPage from "../../pages/drug-generics/CreateDrugGenericPage";
import DrugGenericsPage from "../../pages/drug-generics/DrugGenericsPage";
import EditDrugGenericPage from "../../pages/drug-generics/EditDrugGenericPage";
import CreateDrugLicensePage from "../../pages/drug-licenses/CreateDrugLicensePage";
import DrugLicensesPage from "../../pages/drug-licenses/DrugLicensesPage";
import EditDrugLicensePage from "../../pages/drug-licenses/EditDrugLicensePage";
import CreateHospitalPage from "../../pages/hospitals/CreateHospitalPage";
import EditHospitalPage from "../../pages/hospitals/EditHospitalPage";
import HospitalsPage from "../../pages/hospitals/HospitalsPage";
import ViewHospitalPage from "../../pages/hospitals/ViewHospitalPage";
import { CreateHSNCodePage } from "../../pages/hsn-codes/CreateHSNCodePage";
import { EditHSNCodePage } from "../../pages/hsn-codes/EditHSNCodePage";
import { HSNCodesPage } from "../../pages/hsn-codes/HSNCodesPage";
import CreateLoyaltyProgramPage from "../../pages/loyalty-programs/CreateLoyaltyProgramPage";
import EditLoyaltyProgramPage from "../../pages/loyalty-programs/EditLoyaltyProgramPage";
import LoyaltyProgramsPage from "../../pages/loyalty-programs/LoyaltyProgramsPage";
import { CreateManufacturerPage } from "../../pages/manufacturers/CreateManufacturerPage";
import { EditManufacturerPage } from "../../pages/manufacturers/EditManufacturerPage";
import { ManufacturersPage } from "../../pages/manufacturers/ManufacturersPage";
import { ViewManufacturerPage } from "../../pages/manufacturers/ViewManufacturerPage";
import { NotificationsPage } from "../../pages/notifications/NotificationsPage";
import PhysicalStockCountsPage from "../../pages/physical-stock-counts/PhysicalStockCountsPage";
import { ProfilePage } from "../../pages/ProfilePage";
import CreateRackLocationPage from "../../pages/rack-locations/CreateRackLocationPage";
import EditRackLocationPage from "../../pages/rack-locations/EditRackLocationPage";
import RackLocationsPage from "../../pages/rack-locations/RackLocationsPage";
import { InvoiceCustomizationPage } from "../../pages/settings/InvoiceCustomizationPage";
import { NotificationSettingsPage } from "../../pages/settings/NotificationSettingsPage";
import { PharmacyInformationPage } from "../../pages/settings/PharmacyInformationPage";
import { PrinterSettingsPage } from "../../pages/settings/PrinterSettingsPage";
import { SettingsPage } from "../../pages/settings/SettingsPage";
import { CreateStockTransferPage } from "../../pages/stock-transfers/CreateStockTransferPage";
import { ReceiveStockTransferPage } from "../../pages/stock-transfers/ReceiveStockTransferPage";
import StockTransferDetailPage from "../../pages/stock-transfers/StockTransferDetailPage";
import { StockTransfersPage } from "../../pages/stock-transfers/StockTransfersPage";
import {
  PaymentFailurePage,
  PaymentHistoryPage,
  PaymentSuccessPage,
  SubscriptionOverviewPage,
  SubscriptionPage,
} from "../../pages/subscription";

export const protectedAdvancedRoutes = (
  <>
    <Route
      path="/manufacturers"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SUPPLIER_MGMT}>
          <ManufacturersPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/manufacturers/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SUPPLIER_MGMT}>
          <CreateManufacturerPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/manufacturers/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SUPPLIER_MGMT}>
          <ViewManufacturerPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/manufacturers/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SUPPLIER_MGMT}>
          <EditManufacturerPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/doctors"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DOCTOR_MGMT}>
          <DoctorsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/doctors/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DOCTOR_MGMT}>
          <CreateDoctorPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/doctors/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DOCTOR_MGMT}>
          <ViewDoctorPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/doctors/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DOCTOR_MGMT}>
          <EditDoctorPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/hsn-codes"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.COMPLIANCE}>
          <HSNCodesPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/hsn-codes/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.COMPLIANCE}>
          <CreateHSNCodePage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/hsn-codes/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.COMPLIANCE}>
          <EditHSNCodePage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/stock-transfers"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.MULTI_STORE}>
          <StockTransfersPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/stock-transfers/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.MULTI_STORE}>
          <CreateStockTransferPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/stock-transfers/:id/receive"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.MULTI_STORE}>
          <ReceiveStockTransferPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/stock-transfers/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.MULTI_STORE}>
          <StockTransferDetailPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/billing-sessions"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <BillingSessionsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/billing-sessions/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <ViewBillingSessionPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/billing-sessions/open"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <OpenBillingSessionPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/billing-sessions/:id/close"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SALES_MGMT}>
          <CloseBillingSessionPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/drug-generics"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DRUG_GENERICS}>
          <DrugGenericsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/drug-generics/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DRUG_GENERICS}>
          <CreateDrugGenericPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/drug-generics/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DRUG_GENERICS}>
          <EditDrugGenericPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/rack-locations"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <RackLocationsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/rack-locations/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <CreateRackLocationPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/rack-locations/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <EditRackLocationPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/discount-schemes"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DISCOUNT}>
          <DiscountSchemesPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/discount-schemes/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DISCOUNT}>
          <CreateDiscountSchemePage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/discount-schemes/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DISCOUNT}>
          <EditDiscountSchemePage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/loyalty-programs"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.LOYALTY_PROGRAM}>
          <LoyaltyProgramsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/loyalty-programs/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.LOYALTY_PROGRAM}>
          <CreateLoyaltyProgramPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/loyalty-programs/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.LOYALTY_PROGRAM}>
          <EditLoyaltyProgramPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/drug-licenses"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DRUG_LICENSE}>
          <PermissionProtectedRoute requiredPermission="compliance:view">
            <DrugLicensesPage />
          </PermissionProtectedRoute>
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/drug-licenses/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DRUG_LICENSE}>
          <PermissionProtectedRoute requiredPermission="compliance:manage">
            <CreateDrugLicensePage />
          </PermissionProtectedRoute>
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/drug-licenses/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.DRUG_LICENSE}>
          <PermissionProtectedRoute requiredPermission="compliance:manage">
            <EditDrugLicensePage />
          </PermissionProtectedRoute>
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/physical-stock-counts"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <PhysicalStockCountsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/physical-stock-counts/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <Navigate to="/physical-stock-counts" replace />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/physical-stock-counts/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.INVENTORY}>
          <Navigate to="/physical-stock-counts" replace />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/hospitals"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.HOSPITAL_MGMT}>
          <HospitalsPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/hospitals/create"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.HOSPITAL_MGMT}>
          <CreateHospitalPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/hospitals/:id"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.HOSPITAL_MGMT}>
          <ViewHospitalPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/hospitals/:id/edit"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.HOSPITAL_MGMT}>
          <EditHospitalPage />
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/settings"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SETTINGS}>
          <PermissionProtectedRoute requiredPermission="settings:view">
            <SettingsPage />
          </PermissionProtectedRoute>
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/settings/pharmacy-information"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SETTINGS}>
          <PermissionProtectedRoute requiredPermission="settings:view">
            <PharmacyInformationPage />
          </PermissionProtectedRoute>
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/settings/notifications"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SETTINGS}>
          <PermissionProtectedRoute requiredPermission="settings:view">
            <NotificationSettingsPage />
          </PermissionProtectedRoute>
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/settings/printers"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SETTINGS}>
          <PermissionProtectedRoute requiredPermission="settings:view">
            <PrinterSettingsPage />
          </PermissionProtectedRoute>
        </ModuleProtectedRoute>
      }
    />
    <Route
      path="/settings/invoice-customization"
      element={
        <ModuleProtectedRoute requiredModule={MODULE_CODES.SETTINGS}>
          <PermissionProtectedRoute requiredPermission="settings:view">
            <InvoiceCustomizationPage />
          </PermissionProtectedRoute>
        </ModuleProtectedRoute>
      }
    />
    <Route path="/profile" element={<ProfilePage />} />
    <Route path="/notifications" element={<NotificationsPage />} />
    <Route path="/subscription" element={<SubscriptionPage />} />
    <Route
      path="/subscription/overview"
      element={<SubscriptionOverviewPage />}
    />
    <Route path="/subscription/success" element={<PaymentSuccessPage />} />
    <Route path="/subscription/failure" element={<PaymentFailurePage />} />
    <Route path="/subscription/history" element={<PaymentHistoryPage />} />
  </>
);
